import React from 'react'
import propTypes from 'prop-types'
import {isNil, isString} from 'lodash'
import Checkbox from '@material-ui/core/Checkbox'
import themeVars from 'theme/themeVars'
import Icon from 'components/icon'

const CheckboxStyle = {
  width: 24,
  height: 24,
}
const CheckboxLabelStyle = {
  fontSize: 14,
  color: themeVars.palette.lightTextColor,
  marginLeft: 8,
}

const Option = (props) => {
  const {
    onClickHandler = () => {
    },
    label = '',
    id,
    icon,
    classFtn = (input) => (input),
    showCheck = false,
    checked = false,
  } = props

  let nodeIcon
  if (!isNil(icon)) {
    if (isString(icon)) {
      nodeIcon = (<Icon name={icon}/>)
    } else {
      nodeIcon = icon
    }
  } else {
    nodeIcon = (<Icon name='right'/>)
  }

  if (showCheck) {
    return (
      <div
        className={classFtn('childOption')}
        style={{display: 'flex', alignItems: 'center', margin: '6px 0 6px 14px'}}>
        <Checkbox
          style={CheckboxStyle}
          checked={checked}
          onChange={(e, v) => onClickHandler(id, v)}
        />
        <span style={{...CheckboxLabelStyle, cursor: 'pointer'}} onClick={() => onClickHandler(id, !checked)}>
          {label}
        </span>
      </div>
    )
  }

  return (
    <li className={classFtn('childOption')} onClick={() => onClickHandler(id)}>
      {nodeIcon}
      <div className={classFtn('nodeText')}>
        {label}
      </div>
    </li>
  )
}

Option.propTypes = {
  onClickHandler: propTypes.func,
  label: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  id: propTypes.any,
  icon: propTypes.string,
  classFtn: propTypes.func,
  showCheck: propTypes.bool,
  checked: propTypes.bool,
}

export default Option
